<template>

  <div style="position: relative">

    <el-tabs value="name">
      <el-tab-pane :label="tagName" name="name"></el-tab-pane>

    </el-tabs>

    <div style="position: absolute;top: 10px;right: 0px;">
      <div style="display: inline-block; margin-right: 4px">
        <i class="el-icon-s-home"></i>
      </div>
      <!--                <div style="display: inline-block; font-size: 14px;margin: 0 auto">当前位置：</div>-->
      <div style="display: inline-block">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">网站首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{tagName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'TitleTagsHead',
  data () {
    return {
      // tagName: ''
    }
  },
  props: {
    // tags: Array, // 标签数组
    tagName: String // 标签名
  },
  methods: {
    // init () {
    //   for (var i = 0; i < this.tags.length; i++) {
    //     console.log(this.$route.path)
    //     console.log(this.tags[i].path)
    //
    //     if (this.tags[i].path === this.$route.path) {
    //       this.tagName = this.tags[i].name
    //     }
    //   }
    // }
  },
  mounted () {
    // this.init()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/widgets/TitleTagsHead.vue